<template>
  <section v-if="!isPageLoading" class="selected-path">
    <div
      class="selected-path__background"
      :style="
        `background-image: url(${$getPlaylistBackground(
          learningPath.id
        )}), linear-gradient(#151515, #262626);`
      "
    >
      <div class="selected-path__overlay"></div>
    </div>
    <article class="selected-path__content">
      <div class="selected-path__wrapper">
        <learning-path-overview
          :title="learningPath.title"
          :description="learningPath.description"
          :totalCourses="totalCourses"
          :instructors="learningPath.instructors"
          :duration="$duration.durationOn(learningPath.duration)"
          :difficulty="
            learningPath.difficulties && learningPath.difficulties.data[0]
              ? learningPath.difficulties.data[0].rating
              : 0
          "
          :activities="learningPath.activities"
          :isAuthenticated="isAuthenticated"
          :progress="
            pathProgress && pathProgress.progress ? pathProgress.progress : 0
          "
          :floatedProgress="floatedProgress"
          :pathResume="pathResume"
          :sampleVideoId="getSampleVideoId(learningPath.id)"
          @resumePath="resumePath()"
          @searchPresenter="searchPresenter"
        ></learning-path-overview>
        <learning-path-group
          v-for="group in learningPath.groups"
          :key="group.id"
          :group="group"
          :isAuthenticated="isAuthenticated"
          :userId="userId"
          :progress="userProgress(group.courses)"
        ></learning-path-group>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import LearningPathOverview from '../components/learning-paths/LearningPathOverview.vue'
import LearningPathGroup from '../components/learning-paths/LearningPathGroup.vue'

export default {
  name: 'SelectedPath',
  components: {
    LearningPathOverview,
    LearningPathGroup,
  },
  computed: {
    ...mapGetters({
      isPageLoading: 'app/isPageLoading',
      learningPath: 'learningPaths/selectedLearningPath',
      allProgress: 'user/allProgress',
      isAuthenticated: 'auth/isAuthenticated',
      userId: 'auth/userId',
      pathProgress: 'user/pathProgress',
      pathResume: 'user/pathResume',
      isCordova: 'app/isCordova',
    }),
    totalCourses() {
      let total = 0
      this.learningPath.groups.map(group => {
        total += group.courses.length
      })
      return total
    },
    floatedProgress() {
      if (this.pathProgress && this.pathProgress.progress) {
        return this.pathProgress.progress
        // return this.pathProgress.progress < 10 ? parseFloat(`0.0${this.pathProgress.progress}`) : parseFloat(`0.${this.pathProgress.progress}`)
      }
      return 0
    },
  },
  methods: {
    userProgress(groupCourses) {
      if (!groupCourses || groupCourses.length === 0) {
        return null
      }
      const progress = []
      if (this.allProgress && this.allProgress.courses) {
        this.allProgress.courses.map(userCourse => {
          groupCourses.map(course => {
            if (course.id === userCourse.id) {
              progress.push(userCourse)
            }
          })
        })
      }
      return progress
    },
    openCourse(course) {
      this.$router.push({
        name: 'course',
        params: { id: course.id, slug: course.slug },
      })
    },
    resumePath() {
      this.$store.dispatch(
        'content/setPlayingVideoId',
        this.pathResume.video.id
      )
      this.$store.dispatch('content/setPlayingVideoTime', 0)
      this.$router.push({
        name: 'course',
        params: {
          id: this.pathResume.course.id,
          slug: this.pathResume.course.slug,
        },
      })
    },
    searchPresenter(name) {
      this.$store.dispatch('search/setSearchQuery', '')
      if (this.isCordova) {
        this.$store.dispatch('search/setSearchQuery', name)
        this.$router.push({ name: 'search' })
      } else {
        this.$router.push({ name: 'search', query: { instructor: name } })
      }
    },
    getSampleVideoId(id) {
      switch (id) {
        case 'bfae070e-4ed4-4036-990f-e32b1061f38f':
          return '349101196'
        case '57bb4e03-d841-4137-a1cc-9fb2b6ce362d':
          return '349095538'
        case 'a2ff47e9-018d-4f41-b8f2-9462e182abef':
          return '349104843'
        case '00f8edb4-bd72-41ca-a423-6d31c8caebce':
          return '349109579'
        case 'c51c61f0-efeb-42b4-96e9-6a15f8e08b47':
          return '349098876'
        case '71d690ef-e707-49e0-aea9-a7d8f1a02c91':
          return '349109291'
        case 'e0130226-10f3-4391-bc5d-400381eb2efc':
          return '349096999'
        case '5f0dac37-559e-4670-bd38-546485345fe2':
          return '349109051'
        case '90b43bee-6cc7-43eb-b8d1-1d66f4aa0dcd':
          return '351295680'
        case '62387261-a355-46cd-be26-6fe1d2f17f62':
          return '366855968'
        default:
          return null
      }
    },
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    if (this.isAuthenticated && this.userId) {
      await this.$store.dispatch('user/getAllUserCourseProgress', this.userId)
      await this.$store.dispatch('user/getUserPathProgress', {
        userId: this.userId,
        pathId: this.$route.params.id,
      })
      await this.$store.dispatch('user/getUserPathResume', {
        userId: this.userId,
        pathId: this.$route.params.id,
      })
    }
    await this.$store.dispatch(
      'learningPaths/getSelectedLearningPath',
      this.$route.params.id
    )
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.selected-path {
  position: relative;
  &__background {
    min-height: 100vh;
    width: 100%;
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
  }
  &__overlay {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.1),
      var(--dark-gray),
      var(--dark-gray)
    );
    z-index: 0;
    min-height: 100vh;
    width: 100%;
  }
  &__content {
    padding: 50px 0 0 0;
    @include tablet {
      padding: 150px 75px;
    }
  }
  &__wrapper {
    position: relative;
    background-color: rgba(0, 0, 0, 0.4);
  }
}
</style>
